import React from 'react';
import Firebase from '../Config/firebase';

export const GlobalContext = React.createContext();

export const GlobalDataContext = ( { children } ) => {
    const [loading, setLoading] = React.useState(false);
    
    // 
    const [titlePage, setTitlePage] = React.useState('Dashboard');
    const [descriptionPage, setDescriptionPage] = React.useState('Administre seu negócio aqui');
    
    function setHeaderData(title, description){
        setTitlePage(title);
        setDescriptionPage(description);
    }

    // 
    const [message, setMessage] = React.useState('');
    const [stateMessage, setStateMessage] = React.useState(0);

    function showMessage(messageHeader, stateMessageHeader){
        setMessage(messageHeader);
        setStateMessage(stateMessageHeader);
    }

    // 
    const [currentUser, setCurrentUser] = React.useState(null);
    
    React.useEffect(() => {
        Firebase.auth().onAuthStateChanged(user => 
          setCurrentUser(user)
        );

    }, [currentUser]);
    
    return (
        <GlobalContext.Provider value={{
            loading,
            setLoading,

            titlePage,
            descriptionPage,
            setHeaderData,

            showMessage,
            message,
            stateMessage,

            currentUser,
            setCurrentUser
        }}>
            {children}
        </GlobalContext.Provider>
    )
}